import { ErrorBoundary } from "@sentry/react";
import { API } from "@swivl-mono/api-helper";
import { APIErrorNames, APIServiceConfigInterface } from "@swivl-mono/types";
import { error } from "console";
import { StrictMode } from "react";
import * as ReactDOM from "react-dom/client";

import App from "./App/App";
import "./Helpers/Sentry/Sentry.tsx";
import AccountModel from "./Models/Account/AccountModel";
import { Member } from "./Models/Member/Member.Current";
import "./styles.scss";
import { TimeHelper } from "./Helpers/Time/Time.Helper";
import ErrorView from "./Components/ErrorView/ErrorView";


const serverConfig: APIServiceConfigInterface = {
  url: import.meta.env.VITE_SERVER_URL,

  authCallBack: () => {
    return Member.jwt ? Member.jwt : "";
  },
  tokenType: "member",
  errorCallback: (e) => {
    if (e.message === APIErrorNames.INVALID_TOKEN_EXPIRED) {
      AccountModel.logOut();
    }
    throw new Error(e.message);
  },
};

const syncServerConfig: APIServiceConfigInterface = {
  url: import.meta.env.VITE_SYNC_SERVER_URL,
  authCallBack: () => {
    return Member.jwt ? Member.jwt : "";
  },
  tokenType: "member",
  errorCallback: (e) => {
    if (e.message === APIErrorNames.INVALID_TOKEN_EXPIRED) {
      AccountModel.logOut();
    }
    throw new Error(e.message);
  },
};
const bullServerConfig: APIServiceConfigInterface = {
  url: import.meta.env.VITE_BULL_SERVER_URL,
  authCallBack: () => import.meta.env.VITE_API_TOKEN,
  errorCallback: (e) => {
    throw new Error(e.message);
  },
};

// const notificationsServerConfig: APIServiceConfigInterface = {
//   url: import.meta.env.VITE_NOTIFICATIONS_SERVER_URL,
//   authCallBack: () => {
//     return Member.jwt ? Member.jwt : '';
//   },
//   errorCallback: (e) => {
//     if (e.message === APIErrorNames.INVALID_TOKEN_EXPIRED) {
//       AccountModel.logOut();
//     }
//     throw new Error(e.message);
//   },
// };
API.init({ Server: serverConfig, Bull: bullServerConfig, Sync: syncServerConfig });

const root = ReactDOM.createRoot(document.getElementById("root") as HTMLElement);

TimeHelper.startSyncingTime()

root.render(
  // <StrictMode>
  <ErrorBoundary fallback={<ErrorView />}>
    <App />
  </ErrorBoundary>,
  // </StrictMode>
);
